import styled from 'styled-components';
import thereef from './../../_static/others/beach.jpeg';
import logo from './../../_static/thereef-logo.png';

export const BackgroundReefResorts = styled.div`
  position: relative;
  width: 98%;
  max-width: 90%;
  margin: 30vh auto 60px;
  padding: 80px 0px 60px;
  border-radius: 50px;
  background-color: #fff;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);

  .logo {
    position: absolute;
    background: url(${logo}) center center no-repeat;
    background-size: contain;
    height: 100px;
    min-width: 100px;
    width: 320px;
  }

  .title {    
    padding-left: 20px;
    height: 80px;    
  }

  #page-title {
    background: url(${thereef}) repeat-y ;
    background-size: cover;
  }
  
  img {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;    
  }
`;